import { useLang } from "../i18n/LanguageContext";
import { Link, useLocation } from "react-router-dom";
import LanguageToggle from "./LanguageToggle";

export default function TopBar() {
  const { t, lang } = useLang();
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");
  const es = lang === "es";

  const links = [
    { to: "/", label_es: "Inicio", label_en: "Home" },
    { to: "/programs", label_es: "Programas", label_en: "Programs" },
    { to: "/elite", label_es: "Elite", label_en: "Elite" },
    { to: "/register", label_es: "Registro", label_en: "Register" },
    { to: "/portal", label_es: "Portal Padres", label_en: "Parent Portal" },
  ];

  return (
    <header className="sticky top-0 z-50 border-b border-[#1a1a1a] bg-[#080808]/85 backdrop-blur-md">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="brand-link">
          <div className="w-9 h-9 rounded-lg bg-[#e8559a] flex items-center justify-center text-xl shadow-lg shadow-[#e8559a]/30 group-hover:scale-105 transition-transform">
            ⚽
          </div>
          <div className="leading-tight hidden sm:block">
            <div className="font-bebas text-xl tracking-[0.18em] text-white">
              SOCCER TROOP
            </div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#e8559a]/80">
              {t("tagline")}
            </div>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => {
            const active = loc.pathname === l.to;
            return (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.to.replace(/\W/g, "") || "home"}`}
                className={`px-3 py-1.5 text-sm rounded-md transition-colors ${active ? "text-[#e8559a]" : "text-neutral-400 hover:text-white"}`}
              >
                {es ? l.label_es : l.label_en}
              </Link>
            );
          })}
        </nav>
        <div className="flex items-center gap-2 sm:gap-3">
          <LanguageToggle />
          <Link
            to={isAdmin ? "/" : "/admin"}
            data-testid="nav-admin-link"
            className="text-xs sm:text-sm text-neutral-400 hover:text-[#e8559a] transition-colors px-2"
          >
            {isAdmin ? (es ? "Salir" : "Exit") : "Admin"}
          </Link>
        </div>
      </div>
      <nav className="md:hidden flex overflow-x-auto gap-1 px-4 pb-2 border-t border-[#1a1a1a]">
        {links.map((l) => {
          const active = loc.pathname === l.to;
          return (
            <Link
              key={l.to}
              to={l.to}
              className={`whitespace-nowrap px-2.5 py-1.5 text-xs rounded-md transition-colors ${active ? "text-[#e8559a] bg-[#e8559a]/10" : "text-neutral-400"}`}
            >
              {es ? l.label_es : l.label_en}
            </Link>
          );
        })}
      </nav>
    </header>
  );
}
